import { render, staticRenderFns } from "./DeleteFileAction.vue?vue&type=template&id=274f2a3a"
import script from "./DeleteFileAction.vue?vue&type=script&lang=js"
export * from "./DeleteFileAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports